// Plan card content: hardcoded mirror of the core's "Plan y uso" plan cards
// (config/locales/es.yml → service_plan_dashboard.plan_cards). Prices are NET.
export const PLATFORM_PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    subtitle: 'Automatiza tus finanzas con IA',
    users: '1 usuario',
    price: 79000,
    priceLabel: '$79.000',
    buttonLabel: 'Elegir Starter',
    buttonVariant: 'outline',
    featuresTitle: 'Incluye',
    features: [
      'Conciliación bancaria - IA',
      'Cobranzas autónomas - IA',
      'Facturación - IA',
      'Envío cotizaciones y pago web',
      'Interacción nativa E-commerce',
      'EERR y Balance - IA',
      'RRHH y APP para rendir gastos',
      'Limitado a un usuario'
    ]
  },
  {
    id: 'pro',
    name: 'Pro',
    subtitle: 'Automatiza tu flujo de trabajo con IA',
    users: 'Usuarios ilimitados',
    price: 149000,
    priceLabel: '$149.000',
    buttonLabel: 'Elegir Pro',
    buttonVariant: 'primary',
    recommended: true,
    featuresTitle: 'Todo lo de Starter, y además',
    features: [
      'Facturas masiva y recurrente',
      'Administración de suscripciones',
      'Plan de cuentas custom',
      'Inventarios',
      'Tablero de trabajo',
      'Usuarios ilimitados'
    ]
  },
  {
    id: 'business',
    name: 'Business',
    subtitle: 'Para medianas y grandes empresas. Libera todo el potencial de la IA',
    users: 'Usuarios ilimitados',
    price: 299000,
    priceLabel: '$299.000',
    buttonLabel: 'Elegir Business',
    buttonVariant: 'outline',
    featuresTitle: 'Todo lo de Pro, y además',
    features: [
      'Workflow de aprobaciones',
      'Centros de costos',
      'Carpeta importación y multimoneda',
      'Agentes Avanzados'
    ]
  }
];

// Display-only pricing (D1/V1): prices are NET CLP and the BACK is the
// authority - the front never sends amounts. Every plan starts with the first
// month at $1.000 net ($1.190 with IVA).
export const IVA_RATE = 0.19;
export const INTRO_PRICE_NET = 1000;

export const grossFromNet = net => Math.round(net * (1 + IVA_RATE));

export const formatCLP = amount => `$${amount.toLocaleString('es-CL')}`;

export const INTRO_PRICE_GROSS = grossFromNet(INTRO_PRICE_NET);

export const findPlatformPlan = planId => PLATFORM_PLANS.find(plan => plan.id === planId);

export const ONBOARDING_PAYMENT_STORAGE_KEY = 'parrotfy_onboarding_payment';

export const saveOnboardingPaymentContext = payload => {
  sessionStorage.setItem(ONBOARDING_PAYMENT_STORAGE_KEY, JSON.stringify(payload));
};

export const loadOnboardingPaymentContext = () => {
  const raw = sessionStorage.getItem(ONBOARDING_PAYMENT_STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const updateOnboardingPaymentContext = updates => {
  const current = loadOnboardingPaymentContext() || {};
  saveOnboardingPaymentContext({ ...current, ...updates });
};

export const clearOnboardingPaymentContext = () => {
  sessionStorage.removeItem(ONBOARDING_PAYMENT_STORAGE_KEY);
};
